var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"detail-anchor-card"},[_c('a',{staticClass:"link-a-test",attrs:{"id":_vm.props.info.id}}),_c('div',{staticClass:"detail-header"},[_c('span',[_vm._v(_vm._s(_vm.props.info.label))])]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }